"use strict";
const { parseVariable } = require('./utils');
const { CONSTANT } = require('../definitions/operandTypes');
exports.accepts = ({ type }) => type === CONSTANT;
exports.resolve = (variable) => parseVariable(variable);
//# sourceMappingURL=constantResolver.js.map